<template>
  <div class="mw-panel">
    <div class="mw-tree-search" v-if="search">
      <el-input
        :placeholder="$lang('请输入搜索内容')"
        v-model="searchText"
        clearable>
      </el-input>
    </div>
    <div :class="{'mw-tree-search__body':search,'mw-tree-no-search__body':!search}">
      <div class="mw-tree">

      </div>
    </div>
  </div>
</template>
<script>
  export default {

    name: 'MwCompleteSelectedTree',
    props: {
      search:{
        type: Boolean,
        default: false
      },
      //是否自动加载
      autoLoad:{
        type: Boolean,
        default: true
      },
      //默认的根节点条件
      defaultParentId:{
        type: String
      },
      //默认参数
      defaultParams:{
        type: Object
      },
      //加载数据地址
      url: {
        type: String
      },
      //是否打开第一个节点
      expandedFirst: {
        type: Boolean,
        default: false
      },
      //是否异步加载
      async: {
        type: Boolean,
        default: false
      },
      //是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      singleLeaf: {
        type: Boolean,
        default: false
      },
      //多选是否只选最子节点
      multipleLeaf: {
        type: Boolean,
        default: false
      },
      contextMenuItem: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //多选时选中的ID
      checkNodes: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //单选选中ID
      selectNode: {
        type: String,
        default: ''
      },
      // 静态数据
      treeData: {
        type: [Array,Object]
      }
    },
    data() {
      return {
        searchFlag:false,
        searchText:'',
        selectData: {},
        selectParents: [],

        dblClick:false,
        select:false,
        deselect:false,
        check:false
      }
    },
    watch: {
      checkNodes(newIds) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.uncheck_all();
        newIds.forEach(id => {
          let obj = inst.get_node(id);
          inst.check_node(obj);
        })
      },
      selectNode(newId) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
        if (newId) {
          let obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      },
      searchText(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true)
        if(val==''){
          setTimeout(function() {
            tree.clear_search()
          }, 250);
        }else{
          if (this.searchFlag) {
            clearTimeout(this.searchFlag)
          }
          this.searchFlag = setTimeout(function() {
            tree.search(val,true,true)
          }, 250);
        }
      },
      url(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      }
    },
    mounted() {
      if(this.autoLoad){
        this.renderTree();
      }
    },
    destroyed() {
      let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
      if(tree){
        tree.destroy();
      }
    },
    methods: {
      checkAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.select_all();
      },
      unCheckAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
      },
      openAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('open_all');
      },
      closeAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('close_all');
      },
      refresh() {
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      refreshData(data){
        if(!$(this.$el.querySelector('.mw-tree')).jstree(true)){
          this.renderTree();
        }else{
          $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
          $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
        }
      },
      dblClickNodeId(id){
        let me = this, jsTreeEl = $(me.$el.querySelector('.mw-tree'));
        var obj =  jsTreeEl.jstree(true).get_node(id);
        me.dblClick=true;
        if (obj) {
          if(obj.original.type) {
            var parentId = jsTreeEl.jstree(true).get_parent(obj);
            var parentObj= jsTreeEl.jstree(true).get_node(parentId);
            if(parentObj.children.length==1){
              jsTreeEl.jstree(true).delete_node(parentObj);
              me.$emit("dblClick", parentObj.original, jsTreeEl);
            }else{
              jsTreeEl.jstree(true).delete_node(obj);
              me.$emit("dblClick", obj.original, jsTreeEl);
            }
          }else{
            jsTreeEl.jstree(true).delete_node(obj);
            me.$emit("dblClick", obj.original, jsTreeEl);
          }
        }
        me.dblClick=false;
      },
      changeTreeData(data) {

        data.forEach(d => {
          if (!d.text) {
            if (d.name)
              d.text = d.name;
          }
          if (d.children) {
            if (!d.hasChild) {
              d.hasChild = d.children.length;
            }
            if (d.children.length > 0) {
              this.changeTreeData(d.children);
            } else {
              d.type = 'file';
            }
          } else {
            d.children = false;
            d.hasChild = 0;
            //if(!d.type){
            d.type = 'file';
            //}
          }

          if (d.hasChild > 0) {
            if (me.multiple && me.multipleLeaf) {
              d.state = {"disabled": true};
            }
          }

        })
      },
      getInstance(){
        let me=this;
        return $(me.$el.querySelector('.mw-tree')).jsTree(true);
      },
      showNode(id){
        let me=this;
        let obj= $(me.$el.querySelector('.mw-tree')).jsTree(true).get_node(id);
        $(me.$el.querySelector('.mw-tree')).jsTree(true).show_node(obj);
      },

      getSelected() {
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();
        let data=[];
        if (this.multiple) {
          if (selected.length > 0) {
            data = [];
            selected.forEach(id => {
              data.push(tree.get_node(id).original);
            });
          }
        } else {
          if (selected.length > 0) {
            data = tree.get_node(selected[0]).original;
          }
        }
        return data;
      },

      renderTree() {
        let me = this, jsTreeEl = $(me.$el.querySelector('.mw-tree'));
        let plugin = ["types"];
        let items = {};
        if (me.multiple) {
          plugin.push("checkbox");
          plugin.push("wholerow");
        } else {
          plugin.push("wholerow");
        }
        if(me.search){
          plugin.push("search");
        }
        if (me.contextMenuItem.length > 0) {
          plugin.push("contextmenu");
          me.contextMenuItem.forEach(item => {
            items[item.name] = {
              "name": item.name ? item.name : '',
              "label": item.label,
              "icon": item.icon ? item.icon : '',
              "action": function (a) {
                item.func(me.selectData, me.selectParents);
              }
            }
          });
        }
        let data = {};
        if (me.treeData) {
          data = me.treeData
        }

        jsTreeEl.data('jstree', false).empty();
        jsTreeEl.bind("load_node.jstree", function (e, data) {
        /*  let inst = data.instance;
          let set = inst.settings;

          if (set.async && me.expandedFirst) {
            if (data.node && data.node.children && !set.expanded_first) {
              let node = inst.get_node(data.node.children[0]);
              if (node.original && node.original.hasChild > 0) {
                inst.open_node(data.node.children[0]);
              } else {
                inst.select_node(node)
                set.expanded_first = true;
              }
            } else {
              set.expanded_first = true;
            }
          }*/

        }).on("changed.jstree", function (e, data) {
        }).bind("loaded.jstree", function (e, data) {

        }).bind("click.jstree", function(e) {

        }).bind("dblclick.jstree", function(e) {
          var id=e.target.id.substr(0,e.target.id.lastIndexOf('_'));
          me.dblClickNodeId(id);
        }).bind("check_node.jstree", function(e, data) {

        }).bind("select_node.jstree", function(e, data) {


        }).bind("deselect_node.jstree", function(e, data) {

        }).jstree({
          'async': me.async, //url 是一次性加载，还是异步
          'expanded_first': false,//是否已经展开树节点
          'core': {
            "themes": {
              "responsive": false
            },
            "multiple": me.multiple,  //不允许多选
            "check_callback": function (operation, node, node_parent, node_position, more) {
              return true;
            },
            'data': data

          },
          'checkbox': {
            "keep_selected_style": false,
            "three_state": true,
            "visible": true,
            "tie_selection":true
          },
          "plugins": plugin,
          "contextmenu": {
            "items": items
          },
          "types": {
            "#": {
              "icon": "fa fa-folder"
            },
            "file": {
              "icon": "fa fa-leaf"
            },
            "default": {
              "icon": "fa fa-folder"
            }
          },
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/tree/selected.vue